import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { verifyRecoveryCode } from "../api/passwordService";

const RecoverPasswordPage = () => {
    const navigate = useNavigate();

    const [code, setCode] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setError("");
        setLoading(true);

        try {
            const data = await verifyRecoveryCode(code);

            setMessage(data?.message || "Recovery code verified.");

            sessionStorage.setItem("passwordRecoveryCode", code);

            setTimeout(() => {
                navigate("/new-password");
            }, 800);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                "Invalid or expired recovery code."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-10">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 p-8">
                <h2 className="text-3xl font-bold text-center mb-4">
                    Verify Recovery Code
                </h2>

                <p className="text-slate-600 text-center mb-6">
                    Enter the recovery code sent to your email or phone.
                </p>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <input
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Recovery code"
                        className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600"
                        required
                    />

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl transition disabled:opacity-60"
                    >
                        {loading ? "Verifying..." : "Verify Code"}
                    </button>
                </form>

                {message && (
                    <div className="mt-5 p-3 rounded-lg bg-green-100 text-green-700 text-center">
                        {message}
                    </div>
                )}

                {error && (
                    <div className="mt-5 p-3 rounded-lg bg-red-100 text-red-700 text-center">
                        {error}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RecoverPasswordPage;